import { createStateSelectorHook } from 'src/lib/sweetState';
import { UiStore } from 'src/store';

export const useViewState = createStateSelectorHook(UiStore, [
  'showWebinarBanner',
  'showPerformancePredictionsBanner',
]);
